export enum CustomerProductNumberPrefix {
  GL = 'GL #',
  CUSTOMER = 'Cust Prod #',
}
